import { Trans } from '@lingui/macro';
import { Button, Center, Stack, Text } from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';
import { useTypedSearchParams } from 'react-router-typesafe-routes/dom';

import { UiCard } from '../../components/ui/ui-card/ui-card';
import { SignUpForm } from '../../domains/sign-up/sign-up';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import {
  routeResetPassword,
  routeSignIn,
  routeSignUp,
} from '../../router/routes';

import styles from './sign-up.page.module.css';

export const SignUpPage = () => {
  const navigate = useNavigate();
  const [signUpParams] = useTypedSearchParams(routeSignUp);

  const handleSignIn = () => {
    const cont = signUpParams.continue;

    if (cont === 'order-ticket') {
      const tripid = signUpParams.tripid;
      const startStation = signUpParams.startStation;
      const endStation = signUpParams.endStation;

      const path = routeSignIn.buildPath(
        {},
        {
          continue: cont,
          tripid: Number(tripid),
          startStation: Number(startStation),
          endStation: Number(endStation),
        }
      );

      return navigate(path);
    }

    return navigate(routeSignIn.path);
  };

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.headerTitle}>
          <Trans>Регистрация</Trans> <br />
          <Trans>в личном кабинете</Trans>
        </h1>
        <MainSideMenu />
      </header>
      <main className={styles.main}>
        <Stack spacing="sm">
          <UiCard>
            <SignUpForm />
          </UiCard>

          <UiCard>
            <Center>
              <Text>
                <Trans>Забыли пароль?</Trans>
              </Text>
            </Center>
            <Button
              to={routeResetPassword.path}
              component={Link}
              size="md"
              mt="xs"
              variant="outline"
              fullWidth
            >
              <Trans>Изменить пароль</Trans>
            </Button>
          </UiCard>

          <UiCard>
            <Center>
              <Text>
                <Trans>Уже зарегистрированны?</Trans>
              </Text>
            </Center>
            <Button
              size="md"
              mt="xs"
              variant="outline"
              fullWidth
              onClick={handleSignIn}
            >
              <Trans>Войти</Trans>
            </Button>
          </UiCard>
        </Stack>
      </main>
    </div>
  );
};
